export const adCopyTypes = [
  { key: 'default' as const, title: 'Default' as const },
  { key: 'digital' as const, title: 'Digital' as const },
  { key: 'editorial' as const, title: 'Editorial' as const },
  { key: 'newspaper' as const, title: 'Newspaper' as const },
  { key: 'print' as const, title: 'Print' as const },
  { key: 'signboards' as const, title: 'Signboards' as const },
]

export default adCopyTypes
